import { createReducer } from 'redux-starter-kit';
import {
  verifyUserEmail, sendVerificationEmail, sendChangeEmailEmail, changeEmail, fetchEmailSentTo, saveEmailContent, fetchSpecificEmailContent,
} from './emailUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';


/**
 * A Selector for the verifyUserEmail request (Probably not needed as this isn't tied to a screen)
 */
export const selectVerifyUserEmailRequest = (state) => {
  const requestId = state.via.ui.email.verifyUserEmailId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the sendVerificationEmail request
 */
export const selectSendVerificationEmailRequest = (state) => {
  const requestId = state.via.ui.email.sendVerificationEmailId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the sendChangeEmailRequest
 */
export const selectSendChangeEmailRequest = (state) => {
  const requestId = state.via.ui.email.sendChangeEmailRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the sendChangeEmailRequest
 */
export const selectChangeEmailRequest = (state) => {
  const requestId = state.via.ui.email.changeEmailRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the emailSentToRequest
 */
export const selectEmailSentToRequest = (state) => {
  const requestId = state.via.ui.email.emailSentToRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the FetchEmailContentRequest
 */
export const selectFetchEmailContentRequest = (state) => {
  const requestId = state.via.ui.email.allEmailContentRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the SaveEmailContentRequest
 */
export const selectSaveEmailContentRequest = (state) => {
  const requestId = state.via.ui.email.saveEmailContentRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the SpecificEmailContentRequest
 */
export const selectSpecificEmailContentRequest = (state) => {
  const requestId = state.via.ui.email.specificEmailContentRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialEmailState = {
  sendVerificationEmailId: null,
  verifyUserEmailId: null,
  sendChangeEmailRequestId: null,
  changeEmailRequestId: null,
  emailSentToRequestId: null,
  allEmailContentRequestId: null,
  saveEmailContentRequestId: null,
  specificEmailContentRequestId: null,
};

/**
 * A reducer for the login component in the UI.
 */
const emailReducer = createReducer(initialEmailState, {

  [verifyUserEmail]: (state, action) => ({
    ...state,
    verifyUserEmailId: action.payload,
  }),

  [sendVerificationEmail]: (state, action) => ({
    ...state,
    sendVerificationEmailId: action.payload,
  }),

  [sendChangeEmailEmail]: (state, action) => ({
    ...state,
    sendChangeEmailRequestId: action.payload,
  }),

  [changeEmail]: (state, action) => ({
    ...state,
    changeEmailRequestId: action.payload,
  }),

  [fetchEmailSentTo]: (state, action) => ({
    ...state,
    emailSentToRequestId: action.payload,
  }),

  [saveEmailContent]: (state, action) => ({
    ...state,
    saveEmailContentRequestId: action.payload,
  }),

  [fetchSpecificEmailContent]: (state, action) => ({
    ...state,
    specificEmailContentRequestId: action.payload,
  }),

});


export default emailReducer;
